"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePackageName = exports.getMetaFileS3Key = void 0;
function getMetaFileS3Key(bundleName, version) {
    return [normalizePackageName(bundleName), 'meta', version + '.meta.json'].join('/');
}
exports.getMetaFileS3Key = getMetaFileS3Key;
function normalizePackageName(name) {
    return name.replace(/^@(.+)\/(.+)$/, '$1__$2');
}
exports.normalizePackageName = normalizePackageName;
